import { render, staticRenderFns } from "./AppThemeSlotMenu.vue?vue&type=template&id=5fee913a"
import script from "./AppThemeSlotMenu.vue?vue&type=script&lang=js"
export * from "./AppThemeSlotMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports